import {getCookie, setCookie,removeCookie} from "helpers/VanillaCookie";

const CACHE_ENABLED = true;

export default class FreeWheelFMS {

    // Registered in videoTop.js and Instantiated in video_player.tpl.php
    constructor(params)
    {
        // Feature flag for FreeWheel vs. other ad ecosystems
        this.enabled = params.freeWheelAds !== undefined ? params.freeWheelAds : false;
        // e.g. "cbs" vs. "pplus"
        this.brand = params.partner !== undefined ? params.partner : "undefined";
        this.endPoint = '/freewheel/fms.json' ;
        // re: COPPA
        this.profileTypeKids = "KIDS";
        this.dai = params.dai;

        this.configureDebug("FMS", "debugFMS");
        this.debug("FreeWheel " + (this.enabled ? "enabled" : "disabled"));

        if (this.enabled) {
            this.debug("Caching ", CACHE_ENABLED ? "enabled" : "DISABLED");
            this.debug("DAI = ", this.dai ? "true" : "false");
        }
    }

    // get/configure FMS payload: use CBS.Registry for consumers, e.g. smart tag adaptor
    configure()
    {
        // Is FreeWheel enabled?
        if (this.enabled) {

            // promise for consumers
            CBS.Registry.fmsPromise = new Promise((resolve, reject) => {

                let key = this.cacheKey();

                // 1) check cache
                let item = this.cacheGet(key);
                if (Object.keys(item?.data?.fms_params || {}).length > 0) {
                    this.debug("Using data from cache", item);
                    // value for consumers
                    CBS.Registry.fms = item.data.fms_params;
                    resolve();
                    return;
                }

                // 2) fetch from server API
                this.debug("Fetching from server API");
                let url = this.endPoint+"?"+"dai="+(this.dai?1:0);
                let fetchPromise = fetch(url)
                    .then(response => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        return response;
                    })
                    .then(response => {
                        response.json()
                            .then(item => {
                                if (item.success) {
                                    // value for consumers
                                    this.debug("Data from server API:", item);
                                    CBS.Registry.fms = item.data.fms_params;
                                    this.cacheSet(item, key, item.data.fms_id_ttl);
                                    resolve();
                                } else {
                                    this.debug("Fetch error", item);
                                    reject();
                                }
                            })
                    })
                    .catch(error => {
                        this.debug("Fetch error", error);
                        reject();
                    });
            });
        }
    }

    // simple expiring cache based on browser localstorage

    // generate 4 part cache key
    cacheKey()
    {
        let id = CBS.Registry.user.id ? CBS.Registry.user.id : "anon";
        let coppa = CBS.Registry.user.profile_type == this.profileTypeKids;
        let key = this.brand+id+coppa+this.dai;

        return key;
    }

    // get item; assumes JSON.encoded item with expires value - returns object
    cacheGet(key)
    {
        if (!CACHE_ENABLED) {
            return null;
        }
        var item = null;
        if (key) {
            this.debug("Checking cache with key:", key);
            item = localStorage.getItem(key);
            if (item) {
                // check expiration derived from API response TTL
                item = JSON.parse(item);
                if (item.expires <= this.now()) {
                    this.debug("Cached data expired:", key);
                    this.cacheClear(key);
                    item = null;
                }
            }
        }

        return item;
    }

    // set item; JSON encodes item/object, assumes TTL in seconds
    cacheSet(item, key, ttl)
    {
        if (!CACHE_ENABLED) {
            return;
        }
        if (item && key) {
            this.debug("Caching with key:", key);
            if (ttl) {
                item.expires = this.now() + (ttl * 1000);
            }
            localStorage.setItem(key, JSON.stringify(item));
        }
    }

    cacheClear(key)
    {
        if (!CACHE_ENABLED) {
            return;
        }
        this.debug("Clearing from cache:", key);
        localStorage.removeItem(key);
    }

    // convenience: now as Unix timestamp in seconds
    now()
    {
        return new Date().getTime();
    }

    configureDebug(name, paramName)
    {
        this.debugConfig = {};
        this.debugConfig.name = name;
        this.debugConfig.paramName = paramName;

        var value;

        // debug query param ?debugFMS=1
        let urlParams = new URLSearchParams(window.location.search);
        value = urlParams.get(this.debugConfig.paramName);
        if (value !== null) {
            if (value == 1 || value == "true" || value == "yes") {
                value = true;
                setCookie(this.debugConfig.paramName, 1);
            } else if (value == 0 || value == "false" || value == "no") {
                value = false;
                removeCookie(this.debugConfig.paramName);
            }
        } else {
            // cookie value
            value = getCookie(this.debugConfig.paramName);
            if (value !== null) {
                if (value == 1 || value == "true" || value == "yes") {
                    value = true;
                }
            }
        }

            this.debugConfig.enabled = value;
        }

    // debug convenience
    debug(text, param = null)
    {
        if (this.debugConfig.enabled) {
            let string = this.debugConfig.name + ": " + text;
            param ? console.log(string, param) : console.log(string);
        }
    }

}

